import { Shield, Zap, Droplets, Award } from "lucide-react";
import logoFull from "@/assets/logo-benefits.png";

const benefits = [
  {
    icon: Shield,
    title: "Ultieme Bescherming",
    description: "Onze formules bieden langdurige bescherming voor auto's en motoren tegen vuil, UV-straling en omgevingsfactoren.",
  },
  {
    icon: Zap,
    title: "Pro-Grade Performance",
    description: "Ontwikkeld met en voor professionele auto en motor detailers. Showroom-kwaliteit resultaten, elke keer.",
  },
  {
    icon: Droplets,
    title: "Geconcentreerde Formules",
    description: "Hoogwaardige geconcentreerde producten voor auto en motor. Minder nodig voor maximaal resultaat.",
  },
  {
    icon: Award,
    title: "Premium Kwaliteit",
    description: "Alleen de beste ingrediënten. Geschikt voor alle auto's, motoren en voertuigen.",
  },
];

const BenefitsSection = () => {
  return (
    <section className="section-dark relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 grid-pattern opacity-10" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <img 
            src={logoFull} 
            alt="Alienjuice Logo" 
            className="h-12 sm:h-16 w-auto mx-auto mb-6 object-contain"
          />
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Waarom <span className="text-gradient-green">Alienjuice</span>?
          </h2>
          <p className="text-muted-foreground">
            Ontdek waarom professionele detailers en voertuigliefhebbers wereldwijd kiezen voor onze auto en motor verzorgingsproducten
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className="group text-center p-8 card-premium"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-primary/10 border border-primary/20 mb-6 group-hover:bg-primary/20 group-hover:border-primary/40 transition-all duration-300">
                <benefit.icon className="w-8 h-8 text-primary" />
              </div>

              {/* Content */}
              <h3 className="text-lg font-display font-semibold text-foreground mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
